import { render, staticRenderFns } from "./SmallFooterComponent.vue?vue&type=template&id=0c8caeb6"
import script from "./SmallFooterComponent.vue?vue&type=script&lang=js"
export * from "./SmallFooterComponent.vue?vue&type=script&lang=js"
import style0 from "./SmallFooterComponent.vue?vue&type=style&index=0&id=0c8caeb6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports